import * as Yup from "yup";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createFreeTextSelfCheckElementFormValidationSchema = (t: TFunc) =>
	Yup.object().shape({
		title: Yup.string().required(t("validation:titleFieldRequired")),
		text: Yup.string().required(t("validation:textFieldRequired")),
		solutionText: Yup.string().when("enableSolutionReveal", {
			is: true,
			then: (schema) => schema.required(t("validation:solutionTextFieldRequired")),
			otherwise: (schema) => schema.optional(),
		}),
	});
